module.exports = __webpack_public_path__ + "img/img_service.69693989.svg";